import { observable, computed, action } from 'mobx'
import { firebase } from '../constants'
const pad = (filter) => ('00' + filter).slice(-2)

class TrendStore {
  @observable error = null
  @observable count = null
  @observable averages = []
  @observable filter = {
    region: 0,
    denomination: 0,
    attendance: 0
  }

  @computed get nestedFilterCode() {
    const { region, denomination, attendance } = this.filter
    return `${pad(region)}${pad(denomination)}${pad(attendance)}`
  }

  @action.bound setFilter(key, value) {
    this.filter[key] = value
    this.loadTrendsForFilters()
  }
  @action.bound loadTrendsForFilters() {
    this.error = null
    firebase.database()
      .ref(`analytics/nestedData/${this.nestedFilterCode}`)
      .once('value', action(snap => {
        const results = snap.val()
        if (results) {
          this.count = results.count
          this.averages = results.questionAverages
        } else {
          this.averages = []
          this.count = 0
        }
      }))
      .catch(action(err => {
        this.error = err
      }))
  }
}

export default new TrendStore()



// WEBPACK FOOTER //
// ./src/home/trend-store.js